import { TeacherAgreementFooterCombinedProps } from './types';

const usePresenter = (props: TeacherAgreementFooterCombinedProps): TeacherAgreementFooterCombinedProps => {
  return props;
};

export default usePresenter;
